<template>
  <div>
    <Header />
    <div class="content-view-pdf">
      <b-container fluid="md">
        <b-row>
          <b-col cols="12" class="pd-lr-7">
            <div class="title">{{$t('viewPDF.title')}}</div>
            <div class="wrap-pdf">
              <pdf
                v-for="i in numPages"
                :key="i"
                :src="src"
                :page="i"
              ></pdf>
            </div>
            <div class="wrap-download">
              <b-button class="btn-download">{{$t('viewPDF.download')}}</b-button>
            </div>
          </b-col>
        </b-row>
      </b-container>    
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from "@/components/ui/header";
import Footer from "@/components/ui/footer";
import pdf from 'vue-pdf'

var pdfFile = pdf.createLoadingTask('../../pdf/adobe.pdf');
export default {
  name: "viewPDF",
  components: {
    Header,
    Footer,
    pdf
  },
  data() {
    return{
      src: pdfFile,
      numPages: undefined,
    }
  },
  mounted() {
    this.src.then(pdf => {
      this.numPages = pdf.numPages;
    });
  }
}
</script>
<style lang="scss">
  @import "style";
</style>